module.exports = __webpack_public_path__ + "static/media/laal.7516d58e.jpeg";